export const ACCENT = "#D9622B";

export const HOST = {
  name: "Annette Martin",
  company: "Epiphanie Lending (Loan Factory)",
  nmls: "2384016",
  companyNmls: "320841",
  licensedIn: "GA, FL, NC & TN",
  initials: "AM",
  phone: "+1 (843) 991-4579",
  phoneHref: "tel:+18439914579",
  email: "info@epiphanielending.com",
  website: "www.epiphanielending.com",
};

export const ASSETS = {
  headshot: "https://customer-assets-39nsmqrw.emergentagent.net/job_veteran-loan-clarity/artifacts/tkhkv2my_Annette%20Martin.jpg",
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_veteran-loan-clarity/artifacts/dkbkbrz0_Loan%20Factory%20Logo.JPG",
  bg: {
    luxHomeDusk: "https://static.prod-images.emergentagent.com/jobs/f8e04936-3c8e-4a42-be74-c38fd9ce48de/images/8dfcb3f958a0b7e478e12c7a0968edb9c6bba2e17f3edf8777a5410f9e81ced6.jpeg",
    veteranKeys: "https://static.prod-images.emergentagent.com/jobs/f8e04936-3c8e-4a42-be74-c38fd9ce48de/images/b1cc2298d5723c35118f77d6dc485906b0dc773cdf4b9e9753aeb0e4fc6dbff1.jpeg",
    luxHomeEstate: "https://static.prod-images.emergentagent.com/jobs/f8e04936-3c8e-4a42-be74-c38fd9ce48de/images/140bd41ca3751b9ea4636b0aab808abf8209d122320362e714a787072725f036.jpeg",
    veteranFamily: "https://static.prod-images.emergentagent.com/jobs/f8e04936-3c8e-4a42-be74-c38fd9ce48de/images/142c789996f54a7fca119b24b621257d523e358001889009d172ce1caff224ce.jpeg",
  },
};

export const WEBINAR = {
  title: "BOOTS-FIRST VA BENEFIT REVIEW",
  duration: "45 MINUTES",
  moduleCount: 5,
  dateLine: "📅 THURSDAY, OCTOBER 8 AT 7:00 PM EST",
  dateISO: "2026-10-08T19:00:00-04:00",
  calendar: {
    title: "Boots-First VA Benefit Review (Free Live Webinar)",
    details: "Free live VA loan benefit review with Annette Martin (Epiphanie Lending / Loan Factory). Access link will be emailed before the event.",
    location: "Online — link via email",
    startUTC: "20261008T230000Z",
    endUTC: "20261008T234500Z",
  },
  eyebrow: "FREE LIVE VA BENEFIT REVIEW FOR VETERANS & ACTIVE DUTY — GA, FL, NC & TN",
};

export const HERO = {
  h1a: "KNOW EXACTLY WHERE YOU STAND",
  h1b: "ON YOUR VA LOAN BENEFIT—",
  h1c: "FROM SOMEONE WHO'S WALKED THE SAME PATH",
  blockquote: "What if the VA guarantees your loan — but nobody ever explained what that does and doesn't cover?",
  salutation: "Fellow Veteran,",
};

export const BONUSES = [
  "Live Boots-First VA Benefit & Eligibility Review",
  "Reserve & Closing Cost Clarity Walkthrough",
  "Pre-Application Credit & DTI Snapshot (same-day read)",
  "Direct, Personal Veteran-to-Veteran Access Line",
  "A Follow-Up Plan Built Around Your Timeline — Not a Generic Drip",
];

export const FALSE_BELIEFS = [
  "\u201CA VA loan means zero funds needed, anywhere.\u201D",
  "\u201CEvery lender explains the VA benefit the same way, so it doesn't matter who I call first.\u201D",
  "\u201CI should apply to a few lenders and compare before doing anything else.\u201D",
];

export const REVELATION = [
  "Here's the truth: the VA guarantees a portion of your loan to the lender — it doesn't erase closing costs, reserves, or the lender's own requirements. Most veterans I meet were never shown the difference, and that gap is where surprises live.",
  "And no — not every lender walks you through the benefit the same way. Some hand you a rate sheet; a few of us sit down and map the whole picture before you ever apply. Who you talk to first shapes everything that follows.",
  "Firing off multiple applications before understanding your own numbers usually creates confusion, not leverage. In this review, I'll show you what to look at first — your eligibility, your reserves, your credit and DTI snapshot — so any decision you make afterward is an informed one. No outcomes promised. Just clarity, veteran to veteran.",
];

export const AUDIENCE_CARDS = [
  { icon: "🎖️", text: "Veterans Ready to Purchase in the Next 30-60 Days" },
  { icon: "🪖", text: "Active Duty Service Members Preparing to Buy" },
  { icon: "🏠", text: "Guard & Reserve Members Who Qualify for VA Benefits" },
  { icon: "💝", text: "Surviving Spouses with VA Loan Eligibility" },
  { icon: "❓", text: "Anyone Unsure What Their VA Benefit Actually Covers" },
];

export const ROADMAP = [
  { num: "01", label: "STEP ONE", name: "RESERVE", desc: "Claim your free seat in under a minute. No cost, no credit pull, no obligation." },
  { num: "02", label: "STEP TWO", name: "WATCH", desc: "Join the live 45-minute review — 5 modules plus open Q&A, built for GA, FL, NC & TN buyers." },
  { num: "03", label: "STEP THREE", name: "PREPARE", desc: "Leave with your real reserve picture, a credit & DTI snapshot, and questions worth asking." },
  { num: "04", label: "STEP FOUR", name: "DECIDE", desc: "Move on your timeline — ready now or 60+ days out. Judgment-free either way." },
];

export const MODULES = [
  { num: "01", title: "WHAT THE VA GUARANTEE ACTUALLY MEANS", body: "The difference between what the VA guarantees to your lender and what your lender separately requires." },
  { num: "02", title: "YOUR REAL RESERVE PICTURE", body: "Closing-cost reserves, commonly 3-5% of loan amount, explained plainly — no surprises later." },
  { num: "03", title: "YOUR CREDIT & DTI SNAPSHOT", body: "A same-day read on where you stand before you apply anywhere." },
  { num: "04", title: "AVOID THE COMMON MISSTEPS", body: "The misunderstandings that cost veterans a home or weeks of wasted time." },
  { num: "05", title: "YOUR NEXT STEP", body: "A clear, judgment-free plan — whether you're ready now or 60+ days out." },
];

export const BIO = [
  "I'm Annette Martin — a retired Army veteran who navigated her own VA loan with no guidance, no roadmap, and nobody to translate the fine print. I remember exactly how that felt. It's why I do this work the way I do it.",
  "Today I work with veteran and active-duty homebuyers across Georgia, Florida, North Carolina and Tennessee. The pattern I see over and over: the VA benefit is real and powerful, but the way it's explained — or not explained — leaves buyers guessing about what it actually covers and what it costs out of pocket.",
  "This review exists to close that gap. In 45 minutes, we walk through eligibility, reserves, and a same-day credit & DTI read — plainly, boots-first, with zero pressure. It's an educational review, not a loan application, and no outcome is promised. You'll simply know where you stand.",
];

export const PAIN = [
  "You've probably heard \u201Czero down\u201D a dozen times — then hit a wall when someone mentioned reserves, closing costs, or a lender overlay nobody warned you about. Maybe you were told \u201Cnot yet\u201D without anyone explaining what \u201Cyet\u201D even depends on.",
  "The frustrating part isn't the process. It's the guessing — not knowing which numbers actually matter, which ones you can improve, and who's giving you a straight answer versus a sales pitch. That's the exact confusion this review was built to end.",
];

export const TRANSFORMS = [
  "You'll know exactly whether you qualify for a VA loan — not a guess",
  "You'll understand your real reserve and closing-cost picture before you shop for a house",
  "You'll have a clear next step, with no pressure and no obligation",
];

export const TAKEAWAYS = [
  { icon: "🗺️", title: "CLEARER VIEW", desc: "A plain-language map of what your VA benefit does and doesn't cover." },
  { icon: "✅", title: "PREPARATION CHECKLIST", desc: "The exact items to line up before you ever fill out an application." },
  { icon: "💬", title: "QUESTIONS TO ASK", desc: "What to ask any lender — so you can spot a straight answer fast." },
  { icon: "📋", title: "OPTIONAL NEXT STEP", desc: "A follow-up plan built around your timeline. Entirely optional." },
];

export const FAQS = [
  { q: "Is the webinar free?", a: "Yes — completely free. The Boots-First VA Benefit Review is an educational event. There's no ticket, no fee, and nothing to buy during or after the session." },
  { q: "Is this a loan application?", a: "No. This is an educational review of VA loan eligibility and true out-of-pocket costs. Attending does not start an application, and it is not a commitment to lend or borrow." },
  { q: "Will attending affect my credit?", a: "No. There is no hard credit pull required to attend. The same-day credit & DTI snapshot discussed in the session is educational — nothing touches your credit report by attending." },
  { q: "Who is this webinar for?", a: "Veterans, active-duty service members, Guard & Reserve members, and surviving spouses in Georgia, Florida, North Carolina and Tennessee who want clarity on their VA loan benefit — whether buying in 30 days or just starting to research." },
  { q: "What will be covered?", a: "Five modules over 45 minutes: what the VA guarantee actually means, your real reserve and closing-cost picture, your credit & DTI snapshot, common missteps that cost veterans time or a home, and a clear next step — plus live Q&A." },
  { q: "Is it live or on demand?", a: "It's a live review with real-time Q&A, so you can ask questions specific to your situation. Register and you'll receive the date, time, and access details by email." },
  { q: "What happens after I register?", a: "You'll get a confirmation email with the event details and a reminder before we go live. That's it — no sales calls, no drip campaign pressure. Your follow-up is built around your timeline." },
  { q: "Do I have to speak with a loan officer?", a: "No. Attending carries zero obligation. If you want a one-on-one conversation afterward, the veteran-to-veteran access line is there — but it's entirely your call, on your timeline." },
];

export const COMPLIANCE = "This is an educational review, not a loan application or a commitment to lend. No approval, rate, or closing-timeline outcome is promised or guaranteed. Annette Martin, NMLS #2384016 · Loan Factory, broker NMLS #320841. Equal Housing Lender. GA/FL/NC/TN state license numbers pending confirmation before launch.";

export const COPYRIGHT = "© 2026 Epiphanie Lending · WAM.WEBINAR v2.0";

export const CONSENT_TEXT = "I agree to receive email and SMS communications about this event from Annette Martin / Epiphanie Lending. Message & data rates may apply. Reply STOP to opt out at any time. I understand this is a free educational event, not a loan application, and attending requires no hard credit pull.";

export const STATES = ["Georgia", "Florida", "North Carolina", "Tennessee", "Other"];

export const JOURNEYS = [
  "Just researching",
  "Buying in the next 30-60 days",
  "Buying in 60-90 days",
  "90+ days out",
  "Already under contract",
];

export const TICKER_ITEMS = [
  "45 MINUTES",
  "5 CORE MODULES",
  "LIVE Q&A INCLUDED",
  "GEORGIA, FLORIDA, NORTH CAROLINA & TENNESSEE COVERAGE",
  "NO COST TO ATTEND",
  "VA LOAN ELIGIBILITY & TRUE OUT-OF-POCKET COST SPECIALISTS",
];
